import { render, staticRenderFns } from "./descDrawer.vue?vue&type=template&id=6d885d02&scoped=true&"
import script from "./descDrawer.vue?vue&type=script&lang=js&"
export * from "./descDrawer.vue?vue&type=script&lang=js&"
import style0 from "./descDrawer.vue?vue&type=style&index=0&id=6d885d02&prod&lang=css&"
import style1 from "./descDrawer.vue?vue&type=style&index=1&id=6d885d02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d885d02",
  null
  
)

export default component.exports